import { XMarkIcon } from "@heroicons/react/24/outline";
import { WeightedRules } from "./types";

type RuleSectionProps = {
  title: string;
  value: WeightedRules;
  onWeightChange: (value: number) => void;
  onRuleChange: (index: number, value: string) => void;
  onAddRule: () => void;
  onRemoveRule: (index: number) => void;
};

export default function RuleSection({
  title,
  value,
  onWeightChange,
  onRuleChange,
  onAddRule,
  onRemoveRule,
}: RuleSectionProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
          Weight
        </label>
        <input
          type="number"
          min={0}
          className="remove-arrow w-28 rounded-lg border border-gray-200 dark:border-gray-600 px-3 py-2 text-sm text-gray-800 dark:text-gray-100 bg-white dark:bg-darkbg focus:border-entntblue focus:outline-none focus:ring-1 focus:ring-entntblue/20 transition-colors"
          value={value.weight}
          onChange={(e) => onWeightChange(Number(e.target.value))}
        />
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Rules</p>
        {value.rules.map((rule, idx) => (
          <div key={`${title}-rule-${idx}`} className="grid grid-cols-[1fr_36px] items-center gap-2">
            <input
              className="rounded-lg border border-gray-200 dark:border-gray-600 px-3 py-2 text-sm text-gray-800 dark:text-gray-100 bg-white dark:bg-darkbg placeholder-gray-400 focus:border-entntblue focus:outline-none focus:ring-1 focus:ring-entntblue/20 transition-colors"
              value={rule}
              onChange={(e) => onRuleChange(idx, e.target.value)}
              placeholder="Describe a scoring rule…"
            />
            <button
              type="button"
              className="flex h-9 w-9 items-center justify-center rounded-lg border border-red-300 dark:border-red-700 text-red-400 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
              onClick={() => onRemoveRule(idx)}
              aria-label="Remove rule"
            >
              <XMarkIcon className="h-4 w-4" />
            </button>
          </div>
        ))}
        <button
          type="button"
          className="inline-flex items-center gap-1.5 rounded-lg border border-dashed border-entntblue/40 px-3 py-2 text-sm font-medium text-entntblue hover:border-entntblue hover:bg-entntblue/5 transition-colors"
          onClick={onAddRule}
        >
          <span className="text-base leading-none">+</span> Add Rule
        </button>
      </div>
    </div>
  );
}
